import { NSMenuActionProps } from "namirasoft-site-react";
import { AccountRoutes } from "./AccountRoutes";

export class AccountMenus
{
	static sessionViewToken(getIDs: () => string[]): NSMenuActionProps
	{
		return {
			id: "1",
			menu_item: "View Token",
			isActive: () =>
			{
				return getIDs().length === 1;
			},
			onClick: {
				action: () =>
				{
					let id = getIDs()[0];
					window.location.href = AccountRoutes.SessionSign(id);
				},
				showLoading: false
			}
		}
	}
	static serviceSessionViewToken(getIDs: () => string[]): NSMenuActionProps
	{
		return {
			id: "1",
			menu_item: "View Token",
			isActive: () =>
			{
				return getIDs().length === 1;
			},
			onClick: {
				action: () =>
				{
					let id = getIDs()[0];
					window.location.href = AccountRoutes.ServiceSessionSign(id);
				},
				showLoading: false
			}
		}
	}
}